import * as React from 'react';
import { NavLink, TextLink, HomeIcon, UserIcon, CreditCardIcon } from '@repo/ui-web';
import { SettingsIcon } from '@repo/ui-web';

export function LinkShowcase() {
  const [activeLink, setActiveLink] = React.useState('settings');
  const [activeSidebarLink, setActiveSidebarLink] = React.useState('dashboard');

  const handleInlineClick = (link: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    setActiveLink(link);
  };

  const handleSidebarClick = (link: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    setActiveSidebarLink(link);
  };

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          TextLink
        </p>
        <div className="flex flex-wrap gap-4">
          <TextLink href="#">Primary link</TextLink>
          <TextLink href="#" variant="secondary">
            Secondary link
          </TextLink>
          <TextLink href="#" variant="destructive">
            Destructive link
          </TextLink>
          <TextLink href="https://example.com" variant="external">
            External link
          </TextLink>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          NavLink — Inline
        </p>
        <div className="flex gap-4">
          <NavLink href="#" active={activeLink === 'dashboard'} onClick={handleInlineClick('dashboard')}>
            Dashboard
          </NavLink>
          <NavLink href="#" active={activeLink === 'settings'} onClick={handleInlineClick('settings')}>
            Settings
          </NavLink>
          <NavLink href="#" active={activeLink === 'billing'} onClick={handleInlineClick('billing')}>
            Billing
          </NavLink>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          NavLink — Sidebar
        </p>
        <nav className="flex w-56 flex-col gap-1">
          <NavLink href="#" variant="sidebar" active={activeSidebarLink === 'dashboard'} icon={<HomeIcon />} onClick={handleSidebarClick('dashboard')}>
            Dashboard
          </NavLink>
          <NavLink href="#" variant="sidebar" active={activeSidebarLink === 'profile'} icon={<UserIcon />} onClick={handleSidebarClick('profile')}>
            Profile
          </NavLink>
          <NavLink href="#" variant="sidebar" active={activeSidebarLink === 'settings'} icon={<SettingsIcon />} onClick={handleSidebarClick('settings')}>
            Settings
          </NavLink>
          <NavLink href="#" variant="sidebar" active={activeSidebarLink === 'billing'} icon={<CreditCardIcon />} onClick={handleSidebarClick('billing')}>
            Billing
          </NavLink>
        </nav>
      </div>
    </div>
  );
}
